<template>
  <div id="photosRequests">
    <div>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            >
          </v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="pendingRequests"
          :search="search" 
          class="pf-data-table"
          :pagination.sync="pagination" 
        >
          <template v-slot:items="props">
            <tr>
                <td>{{ props.item.account ? props.item.account.name : props.item.name }}</td>
                <td>{{ props.item.account ? props.item.account.nickname : props.item.nickname }}</td>
                <td>{{ props.item.account ? props.item.account.ppn : props.item.ppn }}</td>
                <td>{{ props.item.pending_request_type }}</td>
                <td>{{ formatDateString(props.item.updatedAt, 'MM/DD/YYYY') }}</td>
                <td>
                  <v-btn icon class="ma-0" @click="viewRequest(props.item)" title="View">
                    <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                  </v-btn>
                </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <app-modal :active="showRequestDetails" v-if="showRequestDetails" width="40%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeRequestDetails">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Family {{ currentRequest.pending_request_type }} Request</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <v-layout wrap>
              <!-- Content -->
              <v-flex xs12 v-if="currentRequest.pending_request_type === 'Photo'">
                <a :href="currentRequest.original_url || currentRequest.webview_url || currentRequest.thumb_url" target="_blank">
                  <img :src="currentRequest.original_url || currentRequest.webview_url || currentRequest.original_url" :alt="currentRequest.filename" height="170px" />
                </a>
              </v-flex>
              <v-flex xs12 v-else-if="['Letter', 'Blog'].indexOf(currentRequest.pending_request_type) > -1">
                <h4 class="mb-2"><b>{{ currentRequest.title }}</b></h4>
                <div class="ml-2" v-html="currentRequest.description || currentRequest.content"></div>
              </v-flex>
              <v-flex xs12 v-else-if="['Video'].indexOf(currentRequest.pending_request_type) > -1">
                <h4 class="mb-2 flex-center" v-if="currentRequest.name && currentRequest.name !== ''"><b>{{ currentRequest.name }}</b></h4>
                <youtube v-if="currentRequest.type === 'Youtube'" class="pf-youtube-player" :video-id="getIdFromURL(currentRequest.url)"></youtube>
                <vimeo-player v-else-if="currentRequest.type === 'Vimeo'" :video-url="currentRequest.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>
                <video v-else playsinline controls height="150" width="100%">
                  <source :src="currentRequest.url" />
                </video>
              </v-flex>
              <v-flex xs12 v-else-if="['Avatar', 'Banner', 'MobileBanner'].indexOf(currentRequest.pending_request_type) > -1">
                <a :href="currentRequest.pending_request_type === 'Avatar' ? currentRequest.temp_avatar.replace('/thumb/', '/original/') : (currentRequest.pending_request_type === 'Banner' ? currentRequest.temp_banner.replace('/thumb/', '/original/') : currentRequest.temp_mobile_banner.replace('/thumb/', '/original/'))" target="_blank" class="flex-center">
                  <img :src="currentRequest.pending_request_type === 'Avatar' ? currentRequest.temp_avatar : (currentRequest.pending_request_type === 'Banner' ? currentRequest.temp_banner : currentRequest.temp_mobile_banner)" :alt="currentRequest.name" height="170px" />
                </a>
              </v-flex>
            </v-layout>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="updateRequest(currentRequest, 'approve')"
            >
              Approve
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="updateRequest(currentRequest, 'reject')"
            >
              Reject
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-teal"
              @click="closeRequestDetails"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store config */
import swal from 'sweetalert2';
import { request, update, remove, formatDate } from '../../helpers/helpers';
import Vue from 'vue';
import AppModal from '../../components/AppModal';
import { mapGetters } from 'vuex';
import session from '../../helpers/session';

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  components: {
    'app-modal': AppModal,
    'vimeo-player': vueVimeoPlayer
  },
  data: () => ({
    search: '',
    headers: [
      { text: 'Family', value: 'account.name', align: 'left' },
      { text: 'Nickname', value: 'account.nickname', align: 'left' },
      { text: 'PPN', value: 'account.ppn', align: 'left' },
      { text: 'Type', value: '' },
      { text: 'Updated', value: 'updatedAt' },
      { text: '', sortable: false }
    ],
    pendingRequests: [],
    pagination: {
      sortBy: 'updatedAt',
      descending: true,
      rowsPerPage: config.dom.rowsPerPage,
    },
    rejectReason: null,
    showRequestDetails: false,
    currentRequest: null,
    requestAPIs: {
      'Avatar': 'Account/{id}/{contentType}/{approveStatus}/{requestFrom}/{authToken}',
      'Banner': 'Account/{id}/{contentType}/{approveStatus}/{requestFrom}/{authToken}',
      'MobileBanner': 'Account/{id}/{contentType}/{approveStatus}/{requestFrom}/{authToken}',
      'Photo': 'Photo/{id}/{approveStatus}/{requestFrom}/{authToken}',
      'Letter': 'Letter/{id}/{approveStatus}/{requestFrom}/{authToken}',
      'Blog': 'Blog/{id}/{approveStatus}/{requestFrom}/{authToken}',
      'Video': 'Video/{id}/{approveStatus}/{requestFrom}/{authToken}'
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency']),
  },
  async created () {
    await this.getRequests();
  },
  methods: {
    async getRequests () {
      let { data, error } = await request(`Agency/Requests/FamilyContent/${this.Agency.id}`, 'GET');
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the pending requests, please try again.'
        };
      } else {
        this.pendingRequests = data;
      }
    },
    viewRequest (item) {
      this.currentRequest = item;
      this.showRequestDetails = true;
    },
    closeRequestDetails () {
      this.currentRequest = null;
      this.showRequestDetails = false;
    },
    getIdFromURL (url) {
      let a = url.split('/embed/')[1];
      return a;
    },
    async updateRequest (item, status) {
      let itemIndex = this.pendingRequests.findIndex(x => x.id === item.id && x.pending_request_type === item.pending_request_type);
      if (itemIndex > -1 && status) {
        swal.fire({
          title: 'Are you sure?',
          text: `Are you sure you want to ${status} the ${this.currentRequest.pending_request_type.toLowerCase()}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: `Yes, ${status} it!`
        }).then(async (result) => {
          if (result.value) {
            (async () => {
              let requestAPI = this.getRequestAPI(item, status);
              let { error, data, status: updateStatus } = await request(requestAPI, 'GET');
              if (error) {
                console.log('error', error);
              } else {
                this.pendingRequests.splice(itemIndex, 1);
                swal.fire(
                  `${status === 'approve' ? 'Approved' : 'Rejected'}!`,
                  `${this.currentRequest.pending_request_type === 'MobileBanner' ? 'Mobile banner' : this.currentRequest.pending_request_type} has been ${status === 'approve' ? 'approved' : 'rejected'}.`,
                  'success'
                );
                this.closeRequestDetails();
              }
            })();
          }
        });
      }
    },
    getRequestAPI (item, status) {
      let url = null;
      if (item && status && this.currentRequest) {
        url = this.requestAPIs[this.currentRequest.pending_request_type];
        url = url.replace('{id}', this.currentRequest._id);
        url = url.replace('{contentType}', this.currentRequest.pending_request_type);
        url = url.replace('{approveStatus}', status);
        url = url.replace('{requestFrom}', 'internal');
        url = url.replace('{authToken}', session.token());
      }
      return url;
    },
    async deletePhoto (item) {
      let itemIndex = this.pendingRequests.findIndex(x => x.id === item.id);
      if (itemIndex > -1) {
        swal.fire({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete the photo? you wont be able to revet this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
          if (result.value) {
            (async () => {
              let { error, data, status } = await remove('Photo', item.id);
              if (error) {
                console.log('error', error);
              } else {
                this.pendingRequests.splice(itemIndex, 1);
                swal.fire(
                  'Deleted!',
                  'Photo has been deleted.',
                  'success'
                );
              }
            })();
          }
        });
      }
    },
    formatDateString (date, format) {
      return formatDate(date, format);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/EditRequests/familyContent.vue